import { Collapse, Box } from "@mui/material";
import { useAutoLoadErrors } from "@rf-hooks/useAutoLoadErrors";
import {
  keysIndicatorsObject,
  PropertyFormSchema
} from "@rf/property/module/components/property-form/util/schemas/property-schema/propertySchema";
import { memo, useState } from "react";
import { useFormContext } from "react-hook-form";

const SeoGlobalErroIndicator = memo(() => {
  const FORM_CONFIG = useFormContext();
  const [errors, setErrors] = useState<{ label: string; value: string }[]>([]);
  const { status } = useAutoLoadErrors(FORM_CONFIG, {
    onLoadErrors: async errors => {
      setErrors(
        Object.keys(errors).map(key => ({ label: key, value: errors[key] }))
      );
    },
    schema: PropertyFormSchema,
    pickFields: keysIndicatorsObject.minimalFieldToGenerateSeo,
    isEdit: true
  });

  return (
    <Box component={"p"} fontSize={13}>
      <Collapse in={!status.isSuccess}>
        <Box component={"span"} alignItems="center">
          Completa estos campos para usar la IA:
        </Box>
        <Box component={"span"} color="error.main" ml={0.3}>
          {errors.map(x => x.label).join(", ")}.
        </Box>
      </Collapse>
    </Box>
  );
});

export default SeoGlobalErroIndicator;
